<div class="container">
    <div class="header" trans>More Like This...</div>

    <div class="titles">
        <media-grid [items]="related" class="full-width small-titles"></media-grid>
    </div>
</div>
